export const handleApiError = (error, errorMessage) => {
    console.error(errorMessage, error);
    if (error.response?.status === 401) {
        console.error('Unauthorized error detected. Redirecting to login page.');
        localStorage.removeItem('userToken');
        localStorage.removeItem('username');
        localStorage.removeItem('user_first_name');
        window.location.href = '/login';
    } else {
        throw error;
    }
}; 